.footer {
	text-align: center;

	a,
	a:link,
	a:visited {
		text-decoration: none;
		display: inline-block;
		margin: 0 8px;

		&:hover, &:focus {
			text-decoration: underline;
		}
	}

	p:first-child {
		margin-bottom: 16px;
	}

	.trademark {
		margin-right: 16px;
	}
}

.dark {
	color: var(--color-white);

	a,
	a:link,
	a:visited {
		color: var(--color-white);

		&:hover, &:focus {
			color: var(--color-white);
		}
	}
}

.light {
	color: var(--color-gray-700);
	padding: 24px 16px;

	a,
	a:link,
	a:visited {
		color: var(--color-gray-700);

		&:hover, &:focus {
			color: var(--color-gray-900);
		}
	}
}
